import {Controller} from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import "flatpickr/dist/flatpickr.min.css"

export default class extends Controller {
    connect() {
        flatpickr(this.element, {
            enableTime: this.data.get("enableTime") === "true",
            dateFormat: "Y-m-d H:i",
            altInput: true,
            altFormat: "m-d-Y h:i K",      // Displayed to user (e.g. 10-24-2025 09:00 PM)
            time_24hr: false               // Optional: switch to 12-hour format
        })
    }
}
